/**
 * @Description: 路由配置
 * @Date: 2019-9-25
 * @Modify:
 * @Author: zhangxiaofeng
 */
// const Home = r => require.ensure([], () => r(require('views/budget/home')), 'Home');
/* Layout */
import Layout from '@/components/layout/Index.vue'

export default [
  {
    path: '/feedback',
    component: Layout,
    redirect: '/feedback/list',
    children: [
      {
        path: 'add',
        component: () => import('@/views/feedback/children/Add'),
        name: 'FeedbackAdd',
        meta: { title: '意见反馈', icon: 'home', noCache: true, keepAlive: false, auth: true }
      },
      {
        path: 'success',
        component: () => import('@/views/feedback/children/Success'),
        name: 'FeedbackSuccess',
        meta: { title: '意见反馈', icon: 'home', noCache: true, keepAlive: false, auth: true }
      },
      {
        path: 'list',
        component: () => import('@/views/feedback/children/List'),
        name: 'FeedbackList',
        meta: { title: '意见反馈', icon: 'home', noCache: true, keepAlive: false, auth: true }
      }
    ]
  }
]
